module.exports = __webpack_public_path__ + "img/7z.ad402933.png";